import React, {useEffect, useState} from 'react';
import {Button, Col, Form, InputGroup, Modal, Row} from "react-bootstrap";
import {useForm, useWatch} from "react-hook-form";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import numberFormat from "../../../helpers/numberFormat";
import moment from "moment";
import _ from "lodash";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import CurrencyPicker from "../../base/components/forms/currencySelector";
import LoadingButton from "../../base/components/loadingButton";
import Loader from "../../../components/loader";

const ServiceQuickEditModal = ({row, onHide, onSaved}) => {
  const [order, setOrder] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios.get('/api/touristServices/' + row.siteId)
      .then(({data}) => {
        const item = _.find(data.order.serviceItems, {idInOneC: row.itemNumber})
        if (!item) {
          window.alert(`Услуга с кодом ${row.itemNumber} не найдена`)
          onHide()
          return
        }
        setOrder(data.order)
      })
      .catch((e) => {
        sayError(e)
        onHide()
      })
      .finally(() => setLoading(false))
  }, [row.siteId]);

  const item = order && _.find(order.serviceItems, {idInOneC: row.itemNumber})

  return (
    <Modal show onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Редактирование услуги</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={'mb-3'}><b>{row.description}</b></div>
        {loading && <Loader/>}
        {item && <QuickServiceForm
          order={order}
          item={item}
          siteId={row.siteId}
          onHide={onHide}
          onSaved={onSaved}
        />}
      </Modal.Body>
    </Modal>
  );
};

const QuickServiceForm = ({order, item, siteId, onHide, onSaved}) => {
  const [saving, setSaving] = useState(false)
  const [currencyType, setCurrencyType] = useState(process.env.REACT_APP_DEFAULT_CURRENCY !== item.currency)
  const formController = useForm({
    defaultValues: {
      ...item,
      issueDate: order.issueDate,
      issuedWithoutDocs: order.issuedWithoutDocs
    }
  })
  const {control, register, getValues, setValue, handleSubmit, formState: {errors}} = formController
  const summCurrency = useWatch({control, name: 'summCurrency'})
  const exchangeRate = useWatch({control, name: 'exchangeRate'})
  const summKZT = useWatch({control, name: 'summKZT'})
  const commission = useWatch({control, name: 'commission'})
  const krsKayar = useWatch({control, name: 'krsKayar'})
  const quantity = useWatch({control, name: 'quantity'})
  const currencyId = useWatch({control, name: 'currency'})
  const issuedWithoutDocs = useWatch({control, name: 'issuedWithoutDocs'})

  const num = (name) => +getValues(name) || 0

  useEffect(() => {
    const currencySum = +summCurrency || 0
    const rate = +exchangeRate || 0
    const currentKzt = +getValues('summKZT') || 0
    if (currencySum !== 0 || (currencySum === 0 && currentKzt !== 0)) {
      let sumKzt = +(currencySum * rate).toFixed(2)
      if (issuedWithoutDocs) sumKzt = Math.ceil(sumKzt)
      setValue('summKZT', sumKzt)
    }
  }, [summCurrency, exchangeRate, issuedWithoutDocs]);

  useEffect(() => {
    if (!currencyId || currencyId === item.currency) return
    if (process.env.REACT_APP_DEFAULT_CURRENCY !== currencyId) {
      axios.post('/api/currencies/exchangeRateByDate', {
        currencyId,
        date: getValues('issueDate').slice(0, 10)
      })
        .then(({data}) => {
          setValue('exchangeRate', data.exchangeRate)
        })
        .catch(sayError)
      setCurrencyType(true)
    } else {
      if (+getValues('exchangeRate') !== 1) {
        setValue('exchangeRate', 1)
      }
      setCurrencyType(false)
    }
  }, [currencyId]);

  const onBlurEmpty = (e, name) => {
    if (e.target.value === '') {
      e.target.value = 0
      setValue(name, 0)
    }
  }
  const onFocusZero = (e) => {
    if (e.target.value === '0') {
      e.target.value = ''
    }
  }
  const howPercentage = (e) => {
    if (e.target.value && e.target.value !== 0) {
      let nextCurrency = num('summCurrency')
      const rate = num('exchangeRate')
      const nextCommission = (nextCurrency * e.target.value / 100) * rate
      nextCurrency = nextCurrency * (100 - e.target.value) / 100
      setValue('summCurrency', nextCurrency)
      setValue('commission', Math.ceil(nextCommission / 10) * 10)
      e.target.value = 0
    }
  }
  const total = ((+summKZT || 0) + (+krsKayar || 0) + (+commission || 0)) * (+quantity || 0)

  const onSubmit = (values) => {
    setSaving(true)
    const numberInputs = ['commission', 'exchangeRate', 'krsKayar', 'summCurrency', 'summKZT']
    const payload = {
      ...order,
      importOneS: true,
      issueDate: moment(order.issueDate, 'DD.MM.YYYY').format('DD.MM.YYYY HH:mm'),
      serviceItems: order.serviceItems.map(service => {
        const next = service.id === item.id
          ? {
            ...service,
            quantity: values.quantity,
            currency: values.currency,
            exchangeRate: values.exchangeRate,
            summCurrency: values.summCurrency,
            summKZT: values.summKZT,
            commission: values.commission,
            krsKayar: values.krsKayar
          }
          : {...service}
        next.startDate = moment(next.startDate, 'DD.MM.YYYY').format('DD.MM.YYYY HH:mm')
        next.endDate = moment(next.endDate, 'DD.MM.YYYY').format('DD.MM.YYYY HH:mm')
        numberInputs.forEach(key => {
          next[key] = +next[key]
        })
        next.tableRecord = next.tableRecord || []
        next.documents = next.documents || []
        return next
      })
    }
    axios.patch('/api/touristServices/' + siteId, payload)
      .then(({data}) => {
        if (typeof data.uploadResult === 'object') {
          window.alert("Загрузка прошла успешно!Но при выгрузке в 1с произошла ошибка. Обратитесь к тех.специалисту")
        }
        onSaved && onSaved()
        onHide()
      })
      .catch(sayError)
      .finally(() => setSaving(false))
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row className={'mb-3'}>
        <Col xs={3}>
          <FormHookInput
            register={register('quantity', {required: true, valueAsNumber: true})}
            label={'Кол-во услуг'}
            type={'number'}
            errors={errors}
          />
        </Col>
      </Row>
      <Row className={'mb-3'}>
        <Col>
          <CurrencyPicker
            value={item.currency}
            key={item.id}
            formController={formController}
            label={'Валюта'}
            name={'currency'}
            errors={errors}
          />
        </Col>
        <Col>
          <FormHookInput
            register={register('exchangeRate', {required: true, valueAsNumber: true})}
            label={'Курс'}
            step={'0.01'}
            type={'number'}
            errors={errors}
            onWheel={(e) => e.target.blur()}
          />
        </Col>
        <Col>
          <FormHookInput
            register={register('summCurrency', {
              required: true,
              valueAsNumber: true,
              onBlur: (e) => onBlurEmpty(e, 'summCurrency')
            })}
            label={'Сумма Вал.'}
            step={'0.01'}
            onFocus={onFocusZero}
            type={'number'}
            errors={errors}
            onWheel={(e) => e.target.blur()}
          />
        </Col>
        <Col xs="auto" style={{width: 72}}>
          <div style={{position: 'relative'}}>
            <label className={'absolutLabel'}>%</label>
            <Form.Control
              defaultValue={0}
              onFocus={onFocusZero}
              onBlur={howPercentage}
              onKeyDown={(e) => {
                if (e.key === 'Enter') e.target.blur()
              }}
              type={'number'}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        </Col>
      </Row>
      <Row className={'mb-3'}>
        <Col>
          <FormHookInput
            register={register('summKZT', {required: true, valueAsNumber: true})}
            label={'СуммаKZT'}
            type={'number'}
            step={'0.01'}
            errors={errors}
            disabled
          />
        </Col>
        <Col>
          <FormHookInput
            register={register('commission', {
              required: true,
              valueAsNumber: true,
              onBlur: (e) => onBlurEmpty(e, 'commission')
            })}
            label={'Комиссия'}
            type={'number'}
            step={'0.01'}
            onWheel={(e) => e.target.blur()}
            onFocus={onFocusZero}
            errors={errors}
          />
        </Col>
        <Col>
          <FormHookInput
            register={register('krsKayar', {
              valueAsNumber: true,
              onBlur: (e) => onBlurEmpty(e, 'krsKayar')
            })}
            label={'КРС Kayar'}
            type={'number'}
            step={'0.01'}
            onFocus={onFocusZero}
            errors={errors}
            onWheel={(e) => e.target.blur()}
          />
        </Col>
        <Col>
          <div style={{position: 'relative'}}>
            <label className={'absolutLabel'}>Калькулятор КРС</label>
            <InputGroup className="mb-3">
              <Form.Control
                onBlur={(e) => {
                  let krs = e.target.value - num('summKZT')
                  if (currencyType) {
                    krs = (e.target.value * num('exchangeRate') - num('summKZT')).toFixed(2)
                  }
                  setValue('commission', krs)
                  e.target.value = ''
                }}
                disabled={num('summKZT') === 0}
                type="number"
              />
              <Button
                variant="outline-secondary"
                type="button"
                onClick={() => setCurrencyType(!currencyType)}
                disabled={num('summKZT') === 0}
              >
                {currencyType ? 'В' : 'Тг'}
              </Button>
            </InputGroup>
          </div>
        </Col>
      </Row>
      <div className={'d-flex justify-content-between align-items-center'}>
        <h5 className={'mt-3'}>Итоговая стоимость: {numberFormat(total)} KZT</h5>
        {num('exchangeRate') > 1 &&
          <div>Комиссия в валюте: {numberFormat(Math.round(num('commission') / num('exchangeRate')))}</div>}
      </div>
      <div className={'d-flex justify-content-end mt-3'}>
        <LoadingButton title={'Сохранить'} loading={saving} type={'submit'}/>
      </div>
    </form>
  );
};

export default ServiceQuickEditModal;
